import React, { Component } from 'react';
import { Modal, Table, Input, InputNumber, DatePicker, Button, message, Spin, Tooltip } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const TextArea = Input.TextArea;

class EditableCell extends Component {
    handleDateChange = (value, dateString) => {
        this.props.onChange(dateString);
    }

    handleInputNumberChange = (value) => {
        this.props.onChange(value);
    }

    handleInputNumberBlur = (e) => {
        const { minScore, maxScore } = this.props;
        const value = e.target.value || 0;
        if (value < minScore || value > maxScore) {
            message.warning('输入的分值不在范围内');
            this.props.onChange('');
        }
    }

    handleInputChange = (e) => {
        this.props.onChange(e.target.value);
    }

    getWebType = () => {
        const { type, value, minScore, maxScore } = this.props;
        const placeholder = `${minScore}~${maxScore}`;
        let dom = null;
        if (type == 'INPUTNUMBER') {
            dom = (
                <InputNumber
                    placeholder={`请输入得分(${placeholder})`}
                    precision={0}
                    value={value}
                    style={{ width: '100%' }}
                    onChange={this.handleInputNumberChange}
                    onBlur={this.handleInputNumberBlur}
                />
            );
        } else if (type == 'DATE') {
            const newValue = value ? moment(value) : null;
            dom = (
                <DatePicker
                    value={newValue}
                    placeholder="请选择"
                    onChange={this.handleDateChange}
                />
            );
        } else if (type == 'INPUT') {
            dom = (
                <Input
                    value={value}
                    placeholder="请输入"
                    style={{ width: '100%' }}
                    onChange={this.handleInputChange}
                />
            );
        }
        return dom;
    }

    render() {
        return (
            <div>{this.getWebType()}</div>
        )
    }
}

class UpdateScore extends Component {
    state = {
        loading: false,
        visible: false,
        params: {},
    }

    show = (record) => {
        this.setState({
            data: [],
            visible: true,
            loading: true,
            params: { ...record },
        }, () => {
            this.getData();
        });
    }

    getData = () => {
        const {
            params: {
                ssuExperienceSharing,
                positivePublicity,
                ssuBusinessPromotion,
                teamContributionScore,
                monthComplained,
                ssuProgressDelayed,
                ssuWorkAffected,
                ssuErrorWorkContributionScore,
            }
        } = this.state;
        const { config } = this.props;
        const data = [];
        data.push({
            type: '团队贡献评分',
            name: 'SSU经验分享',
            scoreValue: ssuExperienceSharing,
            key: 'ssuExperienceSharing',
            maxScore: config.maxSsuExperienceSharing,
            minScore: config.minSsuExperienceSharing,
        }, {
            type: '',
            name: '正能量宣传',
            scoreValue: positivePublicity,
            key: 'positivePublicity',
            maxScore: config.maxPositivePublicity,
            minScore: config.minPositivePublicity,
        }, {
            type: '',
            name: 'SSU业务宣传',
            scoreValue: ssuBusinessPromotion,
            key: 'ssuBusinessPromotion',
            maxScore: config.maxSsuBusinessPromotion,
            minScore: config.minSsuBusinessPromotion,
        }, {
            type: '',
            name: '合计',
            scoreValue: teamContributionScore,
            key: 'teamContributionScore',
        }, {
            type: 'SSU工作失误',
            name: '当月被投诉',
            scoreValue: monthComplained,
            key: 'monthComplained',
            maxScore: config.maxMonthComplained,
            minScore: config.minMonthComplained,
        }, {
            type: '',
            name: '因SSU人员造成进度延误',
            scoreValue: ssuProgressDelayed,
            key: 'ssuProgressDelayed',
            maxScore: config.maxSsuProgressDelayed,
            minScore: config.minSsuProgressDelayed,
        }, {
            type: '',
            name: '因SSU人员影响公司合作',
            scoreValue: ssuWorkAffected,
            key: 'ssuWorkAffected',
            maxScore: config.maxSsuWorkAffected,
            minScore: config.minSsuWorkAffected,
        }, {
            type: '',
            name: '合计',
            scoreValue: ssuErrorWorkContributionScore,
            key: 'ssuErrorWorkContributionScore',
            maxScore: config.maxSsuErrorWorkContributionScore,
            minScore: config.minSsuErrorWorkContributionScore,
        });
        this.setState({
            data,
            loading: false,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => [{
        title: '考核类型',
        dataIndex: 'type',
        width: 160,
        render: (text, record) => {
            const obj = {
                children: text,
                props: {},
            };
            if (text) {
                obj.props.rowSpan = 4;
            } else {
                obj.props.rowSpan = 0;
            }
            return obj;
        }
    }, {
        title: '考核内容',
        dataIndex: 'name',
        width: 250,
        render: (text) => {
            if (text == '合计') {
                return <strong>合计</strong>;
            } else {
                return text;
            }
        }
    }, {
        title: '得分',
        dataIndex: 'scoreValue',
        width: 160,
        render: (text, record, index) => {
            if (record.name != '合计') {
                return this.renderColumns(text, record, 'INPUTNUMBER', false, 'scoreValue', index);
            } else {
                const { data } = this.state;
                let value = 0;
                if (index == 3) {
                    value = this.filterData(data[0].scoreValue) + this.filterData(data[1].scoreValue) + this.filterData(data[2].scoreValue);
                } else if (index == 7) {
                    value = this.filterData(data[4].scoreValue) + this.filterData(data[5].scoreValue) + this.filterData(data[6].scoreValue);
                }
                return <strong>{value}</strong>;
            }
        },
    }]

    filterData = (value) => {
        if (value) {
            const result = parseInt(value, 10)
            return Number.isNaN(result) ? 0 : result;
        } else {
            return 0;
        }
    }

    renderColumns = (text, record, type, disabled, column, index) => {
        return (
            <EditableCell
                disabled={disabled}
                value={text}
                type={type}
                minScore={record.minScore}
                maxScore={record.maxScore}
                onChange={value => this.handleChange(value, index, column)}
            />
        );
    }

    handleChange = (value, index, column) => {
        const { data, params } = this.state;
        data[index][column] = value;
        params[data[index]['key']] = value;
        this.setState({
            data,
            params,
        });
    }

    handleTextAreaChange = (e) => {
        const { params } = this.state;
        params.summaryRemark = e.target.value;
        this.setState({ params });
    }

    submit = () => {
        const {
            params,
            params: {
                summaryRemark,
                ssuExperienceSharing,
                positivePublicity,
                ssuBusinessPromotion,
                monthComplained,
                ssuProgressDelayed,
                ssuWorkAffected,
            }
        } = this.state;
        if (!ssuExperienceSharing && ssuExperienceSharing !== 0) {
            message.warning('请填写SSU经验分享得分');
            return;
        } else if (!positivePublicity && positivePublicity !== 0) {
            message.warning('请填写正能量宣传得分');
            return;
        } else if (!ssuBusinessPromotion && ssuBusinessPromotion !== 0) {
            message.warning('请填写SSU业务宣传得分');
            return;
        } else if (!monthComplained && monthComplained !== 0) {
            message.warning('请填写当月被投诉得分');
            return;
        } else if (!ssuProgressDelayed && ssuProgressDelayed !== 0) {
            message.warning('请填写因SSU人员造成进度延误得分');
            return;
        } else if (!ssuWorkAffected && ssuWorkAffected !== 0) {
            message.warning('请填写因SSU人员影响公司合作得分');
            return;
        }
        if (!summaryRemark || summaryRemark.trim() == '') {
            message.warning('请填写BO总结性评语');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.addSsuMemberScoreGrade,
            data: {
                ...params,
                appraiseUser: null,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const {
            visible,
            params: {
                ssuCode,
                summaryRemark,
                inspectionTime,
                ssuCompellation,
            },
            loading,
            data,
        } = this.state;
        return (
            <Modal
                title="评分"
                visible={visible}
                onCancel={this.hide}
                wrapClassName="vertical-center-modal crcQuarterScore"
                width="660px"
                maskClosable={false}
                footer={
                    <span>
                        <Button type="ghost" size="large" onClick={this.hide}>关闭</Button>
                        <Button type="primary" size="large" onClick={this.submit} loading={loading}>提交</Button>
                    </span>
                }
            >
                <Spin spinning={loading}>
                    <div style={{ position: 'relative' }}>
                        <div style={{ lineHeight: '48px' }}>
                            <span>考核时间：{inspectionTime ? inspectionTime.slice(0, 7) : ''}</span>
                            <span style={{ marginLeft: 32 }}>SSU: {ssuCompellation}({ssuCode})</span>
                        </div>
                        <Table
                            scroll={{ x: 570 }}
                            pagination={false}
                            rowKey={row => row.key}
                            columns={this.getColumns()}
                            dataSource={data}
                        />
                        <div style={{ marginTop: 20, marginBottom: 30 }}>
                            <div>
                                <span style={{ color: 'red' }}>*</span>BO总结性评语：
                                <TextArea
                                    rows={4}
                                    value={summaryRemark}
                                    placeholder="请输入"
                                    onChange={this.handleTextAreaChange}
                                    style={{ width: 517, verticalAlign: 'text-top' }}
                                />
                            </div>
                        </div>
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateScore;


// WEBPACK FOOTER //
// ./src/components/hospital/StaffScore/UpdateScore.js